import "./Friends.css";

const FriendListItem = ({ friend }) => {
  return (
    <li className="friend-item">
      <span className={"status " + (friend.isOnline ? "online" : "offline")}></span>
      <img className="avatar" src={friend.avatar} alt="User avatar" width="48"/>
      <p className="name">{friend.name}</p>
    </li>
  );
};

export const FriendList = ({ friends }) => {
  return (
    <ul className="friend-list">
      {friends.map((friend) => (
        <FriendListItem key={friend.id} friend={friend} />
      ))}
    </ul>
  );
};
